import { render, staticRenderFns } from "./GuppyChatInnerLoader.vue?vue&type=template&id=2fa80425&v-if=listItem&"
import script from "./GuppyChatInnerLoader.vue?vue&type=script&lang=js&"
export * from "./GuppyChatInnerLoader.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatInnerLoader.vue?vue&type=style&index=0&id=2fa80425&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports